module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular.fa2772327f55d8198301fdb8bcfc8158.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
 ** module id = 386
 ** module chunks = 0
 **/